import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Company } from '../company';
import { Utils } from 'services/utils.service';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { Customer } from '../customer';
import { Configuration } from '../../../app.constants';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { User } from '../../../shared/classes/user';
import { Branch } from '../branch';

@Injectable()
export class CustomerService {
  private _customerApiUrl: string = this._configuration.apiUrl + '/v2/customer';
  private _usersUrl: string = this._configuration.apiUrl + '/v2/user';

  constructor(private _http: HttpInterceptorService,
    private _pureHttp: Http,
    private _utils: Utils,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  getCustomers(): Observable<Customer[]> {
    let h: Headers = this._authService.getHeaders();

    //TODO check this for an empty array
    return this._pureHttp.get(this._customerApiUrl, { headers: h, search: null }).map((response: Response) => <Customer[]>response.json().customers);
  }

  getCustomersByBranch(branch_prefix: string): Observable<Customer[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('branch_prefix', branch_prefix);

    //TODO check this for an empty array
    return this._pureHttp.get(this._customerApiUrl, { headers: h, search: s }).map((response: Response) => <Customer[]>response.json().customers);
  }

  getOneCustomer(id: string): Observable<Customer> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);

    return this._pureHttp.get(this._customerApiUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['customers'] == null || !Array.isArray(body['customers']))
          return new Customer();
        return body['customers'][0];
      }
    );

  }

  deleteCustomer(id: number): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id + '');

    return this._pureHttp.delete(this._customerApiUrl, { headers: h, search: s }).map((response: Response) => response);
  }

  createCustomer(c: Customer): Observable<any> {
    let h: Headers = this._authService.getHeaders();

    return this._pureHttp.post(this._customerApiUrl, c, { headers: h, search: null }).map(response => response.json());
  }

  updateCustomer(id: string, c: Customer): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);

    return this._pureHttp.put(this._customerApiUrl, c, { headers: h, search: s }).map(response => response.json());
  }

  getUsersPerBranch(branch_id: string): Observable<User[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('branchUsers', 'true');
    s.append('branch_id', branch_id);

    return this._pureHttp.get(this._usersUrl, { headers: h, search: s }).map(
      (response: Response) => {
        let body = response.json();
        if (body['users'] == null || !Array.isArray(body['users'])) {
          return [];
        }
        return body['users'];
      })

  }

  getOneCustomerBranches(id: string): Observable<{ id: string, branches: Branch[] }> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);
    s.append('branches', 'true');

    return this._pureHttp.get(this._customerApiUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['branches'] == null || !Array.isArray(body['branches']))
          return { id: id, branches: [] };
        return { id: id, branches: body['branches'] };
      }
    );

  }

  getCustomersPerBranch(branch_id: string): Observable<{ id: string, customers: Customer[] }> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('branch_id', branch_id);
    s.append('short', 'true');

    return this._pureHttp.get(this._customerApiUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['customers'] == null || !Array.isArray(body['customers']))
          return { id: branch_id, customers: [] };
        return { id: branch_id, customers: body['customers'] };
      }
    );
  }

  setOneCustomerBranches(id: string, branches: Branch[]) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);
    s.append('branches', 'true');

    return this._pureHttp.put(this._customerApiUrl, { branches: branches }, { headers: h, search: s }).map(response => response.json());
  }

  REPORTS_URL = this._configuration.apiUrl + '/v2/reports';

  getOneCustomerCreditLimitInfo(customer_id) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('operation', 'creditReport');
    s.append('customer_id', customer_id)

    return this._http.get(this.REPORTS_URL, { headers: h, search: s }).map(
      response => {
        let r = response.json()

        if (Array.isArray(r) && r.length > 0) {
          return r[0];
        } else {
          return {}
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/customer/customer.service.ts